import { useEffect, useState, useContext } from "react";
import { Nav, Navbar } from 'react-bootstrap';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import RefreshContext from "../RefreshContext";
import apiClient from "../lib/apiClient";
import isMobile from "../lib/isMobile";
import {accountIconClass} from "./AccountIcon";
import TimeRangePicker from "./TimeRangePicker";
import {BusyStatus} from "./BusyStatus";

export default function LeftNav() {
  const [dataViews, setDataViews] = useState([]);
  const [familyOffice, setFamilyOffice] = useState(null);
  const [accounts, setAccounts] = useState(null);
  const [accountCount, setAccountCount] = useState(0);
  const [itemSelected, setItemSelected] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { refreshKey, refresh } = useContext(RefreshContext);

  useEffect(() => {
    apiClient.get("/api/data_views")
      .then(({ data }) => {
        setDataViews(data);
      }).catch(console.error);

    apiClient.get("/api/accounts")
      .then(({ data, error }) => {
        if (data.length > 0) {
          setAccounts(data.slice(0, 10));
          setAccountCount(data.length)
        }
      }).catch(console.error);

    apiClient("/api/family_office")
      .then(({ data }) => {
        setFamilyOffice(data);
      }).catch(console.error);

    setItemSelected(false);
  }, [refreshKey]);

  function NavLink({ to, title, icon, onClick }) {
    const selected = location.pathname === to;
    if (selected) setItemSelected(true);

    const className = selected ? "nav-link active text-primary bg-body-secondary" : "nav-link";
    return (
      <div className={`d-flex align-items-baseline text-dark ps-2 ${className}`}>
        {icon && <i className={`bi bi-${icon} me-2`} />}
        <Link to={to || '#'} onClick={onClick} className={"text-dark"}>
          {title}
        </Link>
      </div>
    );
  }

  function createView() {
    apiClient.post("/api/data_views", {})
      .then(({ data }) => {
        navigate(`/views/${data.id}#edit`);
        refresh();
      })
      .catch(console.error);

    return "";
  }

  async function loadMore() {
    const { error } = apiClient.get("/api/family_office/load_more")
    if (error) {
      console.error(error);
    }
  };

  if (dataViews.length === 0 || familyOffice === null || familyOffice.status?.is_locked || !accounts) return "";
  if (itemSelected && isMobile()) return "";

  return (
    <Navbar bg="light" expand="lg" className="navbar navbar-vertical position-sticky top-0 vh-100 d-flex flex-column pt-3" style={{maxWidth: '300px', minWidth: '250px'}}>
      <Nav bg={"dark"} variant={"dark"} className={"flex-column d-flex flex-grow-1 overflow-auto w-100"}
        activeKey={location.pathname}>
        <h5 className="ps-2">Views</h5>
        {dataViews.map((dataView) => (
          <NavLink to={"/views/" + dataView.id}
            key={dataView.id}
            title={dataView.name}
            icon="file-bar-graph"
          />
        ))}
        <NavLink onClick={createView}
          title="Create View"
          icon="file-earmark-plus"
        />
        <hr />
        <h5 className="ps-2">Accounts ({accountCount})</h5>
        {accounts.map((account) => (
          <NavLink to={"/accounts/" + account.id}
            key={account.id}
            title={account.name}
            icon={accountIconClass(account.account_type)}
          />
        ))}
        <NavLink to={"/accounts"} title={"All Accounts"} icon='cash-stack'/>
      </Nav>
      <Nav className="flex-column d-flex w-100">
        <BusyStatus/>
        <hr />
        <NavLink onClick={loadMore} icon="arrow-repeat" title={"Update Transactions"} />
        <NavLink to="/settings" title={"Settings"} icon="gear-fill" />
      </Nav>
    </Navbar>
  );
}